module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"searchForm":{"search":"search","searchFunimation":"Search Funimation"}},"es":{"searchForm":{"search":"Buscar","searchFunimation":"Buscar en Funimation"}},"pt":{"searchForm":{"search":"Pesquisar","searchFunimation":"Pesquisar na Funimation"}}}')
  delete Component.options._Ctor
}
